import React, { useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as CounterDashboardActions from "../../redux/actions/CounterDashboardActions";
import moment from "moment";
import "moment/locale/da";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { translate } from "../../utils/i18n";
import { ToastContainer, toast } from "react-toastify";
import {
  BlockPlaceholder,
  ChartComp,
  OpenInGmap,
  CounterServiceThresholdComp,
  SchedulingChartComp,
} from ".";
import "react-toastify/dist/ReactToastify.css";

const CounterDeviceWidget = (props) => {
  const { orgGroups, deviceData } = props;
  const isMobile = window.innerWidth <= 500;
  const [isChartHidden, setisChartHidden] = useState(true);
  const [isBigCard, setisBigCard] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);
  // eslint-disable-next-line
  const [chartResize, setChartResize] = useState(false);
  // eslint-disable-next-line
  const [deviceIconClassName, setDeviceIconClassName] = useState("icon-grid");

  const handleExpandWidget = () => {
    setisBigCard(!isBigCard);
  };

  const handleMoreDetails = () => {
    if (isChartHidden) {
      props.updateDevicesWithDetailsList([
        ...props.devicesWithDetailsList,
        props.deviceData,
      ]);

      switch (props.currntActiveMode) {
        case "DataAnalytics":
          props.UpdateOneTrendsDevicesData(
            orgGroups,
            props.selectedDate,
            props.selectedRef,
            props.selectedPeriod,
            props.DeviceGroup,
            deviceData,
            props.selectedOrganization
          );
          break;
        case "Scheduling":
          props.UpdateOneServiceSchedulingDevicesData(
            orgGroups,
            props.selectedDate,
            props.selectedPeriod,
            props.DeviceGroup,
            deviceData,
            props.selectedOrganization
          );
          break;
        default:
          break;
      }
    } else {
      props.RemoveFromTrendsDevicesData(orgGroups, deviceData);
      props.updateDevicesWithDetailsList([
        ...props.devicesWithDetailsList.filter(
          (device) => device._id !== deviceData._id
        ),
      ]);
    }
    setisChartHidden(!isChartHidden);
  };
  const handleRestService = () => {
    props
      .RestDeviceService(props.selectedOrganization, deviceData, orgGroups)
      .then((response) => {
        if (response.case) {
          setIsResetModalOpen(!isResetModalOpen);
          toast.success(translate("resetSuccessfully"));
        } else {
          toast.error(response.msg.response.data.error);
        }
      });
  };

  const renderTotalSection = () => {
    return deviceData.hasOwnProperty("total") && deviceData.total ? (
      <div className="d-flex align-items-start align-self-stretch flex-column pr-0">
        <p className="h4 mt-2 font-weight-light text-capitalize m-0">
          {translate("totalperson")}
        </p>
        <p className="h1 m-0 mr-4">{deviceData.total}</p>
        <p className="align-self-start mt-auto ">
          {translate("activitiesThisPeriod")}
        </p>
      </div>
    ) : null;
  };

  const renderSummarySection = () => {
    switch (props.currntActiveMode) {
      case "DataAnalytics":
        if (
          deviceData.summary &&
          deviceData.summary !== null &&
          deviceData.summary.hasOwnProperty("last_reading") &&
          deviceData.summary.last_reading !== null &&
          deviceData.summary.last_reading.hasOwnProperty("v") &&
          deviceData.summary.last_reading.v !== null
        )
          return (
            <div className="d-flex flex-column align-items-end align-content-between h-100">
              <p className="h1 m-0">
                {deviceData.summary.last_reading.v}{" "}
                <span className="lead">{translate("counts")}</span>
              </p>
              <p className=" font-weight-normal mb-0">
                {translate("interval")}{" "}
                {moment(deviceData.summary.last_reading.time).format("HH:mm")}
              </p>
              <p className="align-self-end mt-auto ">
                {deviceData.summary.last_reading.time ? (
                  <span className="font-weight-bolds lead">
                    {translate("on")}{" "}
                    {moment(deviceData.summary.last_reading.time).format(
                      "D. MMM. YYYY"
                    )}
                  </span>
                ) : null}
              </p>
            </div>
          );
        else {
          return <React.Fragment></React.Fragment>;
        }

      case "Scheduling":
        if (deviceData.serviceSchedule)
          return (
            <React.Fragment>
              {deviceData.serviceSchedule.hasOwnProperty(
                "totalCountSinceLastReset"
              ) && deviceData.serviceSchedule.totalCountSinceLastReset ? (
                <div className="col-6 d-flex align-items-start align-self-stretch flex-column pl-0">
                  <p className="h4 mt-2 font-weight-light m-0">
                    {translate("totalCounts")}
                  </p>
                  <p className="h1 m-0 mr-4">
                    {deviceData.serviceSchedule.totalCountSinceLastReset}
                  </p>

                  <p className="align-self-start mt-auto">
                    {translate("lastResetAt")}
                    {moment
                      .unix(deviceData.serviceSchedule.lastResetAt)
                      .format("D. MMM. YYYY HH:mm")}
                  </p>
                </div>
              ) : (
                <React.Fragment></React.Fragment>
              )}
              <div
                className={
                  deviceData.serviceSchedule.totalCountSinceLastReset
                    ? "col-6 d-flex flex-column align-items-end align-content-between h-100 pr-0"
                    : "col-12 col-md-6 offset-sm-6 d-flex flex-column align-items-end align-content-between h-100 pr-0"
                }
              >
                <p className="h1 m-0 ml-4">
                  {deviceData.serviceSchedule.serviceTargetCount}
                </p>
                <p className="align-self-end mt-auto">
                  {translate("serviceTarget")}
                </p>
              </div>
            </React.Fragment>
          );
        else return <React.Fragment></React.Fragment>;

      default:
        return <React.Fragment></React.Fragment>;
    }
  };
  const containerStyle = {
    zIndex: 999,
    marginTop: "40px",
  };
  return (
    <Col xs="12" md={isBigCard ? "12" : "6"} lg={isBigCard ? "12" : "6"}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        style={containerStyle}
      />
      <Card className="pb-0 my-3 shadow border-0">
        <CardBody>
          <div className="d-flex flex-row align-content-start w-100 ">
            <div className="d-flex flex-column align-items-start ">
              {!isMobile && (
                <Button
                  color="link"
                  className="nounderline lead pl-0"
                  onClick={() => handleExpandWidget()}
                >
                  <i
                    className={isBigCard ? "fa fa-compress" : "fa fa-expand"}
                  />
                </Button>
              )}
            </div>

            <Link
              to={`/organizations/${props.selectedOrganization._id}/devices/${deviceData._id}`}
              className="h1 text-primary text-right  ml-auto"
            >
              <i className={deviceIconClassName} />
            </Link>
          </div>
          <Row className="d-flex flex-row-reverse justify-content-between align-items-end px-3">
            {renderSummarySection()}
            {renderTotalSection()}
          </Row>
          {/* <Row className="d-flex flex-row justify-content-end align-items-end px-3">
          </Row> */}

          <Row>
            {/* service_treger */}
            <Col xs="12">
              <p className="h4 mt-2">
                {deviceData.name}{" "}
                <span className="text-muted"> {deviceData.device}</span>
              </p>
            </Col>
          </Row>
          {!isChartHidden ? (
            <Row>
              {props.currntActiveMode === "Scheduling" && (
                <React.Fragment>
                  <Col xs="12" className="my-3">
                    <CounterServiceThresholdComp
                      isBigCard={isBigCard}
                      DevicesData={deviceData}
                      DeviceGroup={props.DeviceGroup}
                    />
                  </Col>
                  <Col xs="12">
                    {deviceData.hasOwnProperty("isFetchingData") &&
                    !deviceData.isFetchingData ? (
                      deviceData.hasOwnProperty("schedulingData") &&
                      deviceData.schedulingData.length > 0 ? (
                        <SchedulingChartComp
                          currntActiveMode={props.currntActiveMode}
                          seriesesData={[
                            [
                              [...deviceData.schedulingData],
                              [...deviceData.refData],
                            ],
                          ]}
                          DevicesData={[deviceData]}
                          height={350}
                          chartResize={chartResize}
                          period={props.selectedPeriod}
                        />
                      ) : (
                        <p className="text-center text-info h3">
                          {translate("noDataAvailable")}
                        </p>
                      )
                    ) : (
                      <React.Fragment>
                        <BlockPlaceholder height={350} />
                      </React.Fragment>
                    )}
                  </Col>
                </React.Fragment>
              )}
              {props.currntActiveMode === "DataAnalytics" && (
                <React.Fragment>
                  <Col xs="12">
                    {deviceData.hasOwnProperty("isFetchingData") &&
                    !deviceData.isFetchingData ? (
                      deviceData.trendsData.length > 0 ? (
                        <ChartComp
                          currntActiveMode={props.currntActiveMode}
                          seriesesData={[
                            [
                              [...deviceData.trendsData],
                              [...deviceData.trendsRefData],
                            ],
                          ]}
                          DevicesData={[deviceData]}
                          height={350}
                          chartResize={chartResize}
                          period={props.selectedPeriod}
                        />
                      ) : (
                        <p className="text-center text-info h3">
                          {translate("noDataAvailable")}
                        </p>
                      )
                    ) : (
                      <BlockPlaceholder height={350} />
                    )}
                  </Col>
                </React.Fragment>
              )}
            </Row>
          ) : null}
        </CardBody>
        <hr className="my-0" />
        <div className="d-flex justify-content-around ">
          <Button
            color="link"
            className="nounderline d-flex align-items-center w-49 text-center justify-content-center p-3"
            onClick={handleMoreDetails}
          >
            <i
              className={
                isChartHidden
                  ? "fa fa-chevron-down mr-1 "
                  : "fa fa-chevron-up mr-1"
              }
            />
            <span className="text-left">
              {translate(isChartHidden ? "moreDetails" : "hideDetails")}
            </span>
          </Button>
          <span className="h3 font-weight-light text-info border-left m-0" />
          {props.currntActiveMode === "DataAnalytics" && (
            <React.Fragment>
              <OpenInGmap
                selectedDevice={deviceData}
                useArrowIcon
                addClassName="d-flex align-items-center w-49 text-center justify-content-center p-3"
              />
            </React.Fragment>
          )}
          {props.currntActiveMode === "Scheduling" && (
            <React.Fragment>
              <Button
                color="link"
                className="nounderline d-flex align-items-center w-49 text-center justify-content-center p-3"
                onClick={() => setIsResetModalOpen(!isResetModalOpen)}
              >
                <i className={"fa fa-flag mr-1"} />
                <span className="text-left">{translate("resetService")}</span>
              </Button>
              <Modal isOpen={isResetModalOpen}>
                <ModalHeader>{translate("resetServiceHeader")}</ModalHeader>
                <ModalBody className="lead">
                  {translate("resetServiceMessage")} {deviceData.name}
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="secondary"
                    onClick={() => setIsResetModalOpen(!isResetModalOpen)}
                  >
                    {translate("cancel")}
                  </Button>
                  <Button color="danger" onClick={handleRestService}>
                    <i className="fa fa-repeat" /> {translate("resetService")}
                  </Button>
                </ModalFooter>
              </Modal>
            </React.Fragment>
          )}
        </div>
      </Card>
    </Col>
  );
};

const mapStateToProps = (state) => ({
  orgGroups: state.CounterDashboardReducer.orgGroups,
  selectedRef: state.CounterDashboardReducer.selectedRef,
  selectedDate: state.CounterDashboardReducer.selectedDate,
  selectedPeriod: state.CounterDashboardReducer.selectedPeriod,
  currntActiveMode: state.CounterDashboardReducer.currntActiveMode,
  selectedOrganization: state.CounterDashboardReducer.selectedOrganization,
  trendsDevicesDataList: state.CounterDashboardReducer.trendsDevicesDataList,
  devicesWithDetailsList: state.CounterDashboardReducer.devicesWithDetailsList,

  constAnalyticsRefsList: state.CounterDashboardReducer.constAnalyticsRefsList,
  constAnalyticsPeriodsList:
    state.CounterDashboardReducer.constAnalyticsPeriodsList,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ ...CounterDashboardActions }, dispatch);
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CounterDeviceWidget);
